import React from 'react';

const DrivingEnvironment: React.FC = () => {
  return (
    <svg 
      className="driving-environment-svg" 
      width="100%" 
      height="100%" 
      viewBox="0 0 400 300" 
      fill="" 
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      {/* Sky gradient background */}
      <defs>
        <linearGradient id="skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#E8EEF8" />
          <stop offset="100%" stopColor="#D4DDEE" />
        </linearGradient>
        <linearGradient id="roadGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#6B7280" />
          <stop offset="100%" stopColor="#4B5563" />
        </linearGradient>
      </defs>
      
  {/*
  <rect width="400" height="300" fill="#f0f3f9" />
      
      {/* Clouds */}
      <g className="clouds" opacity="0.6">
        <ellipse cx="80" cy="70" rx="25" ry="15" fill="#E0E7FF" className="cloud cloud-2"/>
        <ellipse cx="100" cy="65" rx="30" ry="18" fill="#E0E7FF" className="cloud cloud-2"/>
        <ellipse cx="120" cy="70" rx="20" ry="12" fill="#E0E7FF" className="cloud cloud-2"/>
        
        <ellipse cx="280" cy="60" rx="30" ry="18" fill="#D1D9F5" className="cloud cloud-2"/>
        <ellipse cx="305" cy="55" rx="25" ry="15" fill="#D1D9F5" className="cloud cloud-2"/>
        <ellipse cx="330" cy="60" rx="20" ry="12" fill="#D1D9F5" className="cloud cloud-2"/>
      </g>
      
      {/* Far mountains/hills */}
      <path d="M0 180 Q100 150 200 170 T400 180 L400 300 L0 300 Z" fill="#B8C5E0" opacity="0.4"/>
      
      {/* Trees in background - left side */}
      <g className="tree tree-far-1" opacity="0.7">
        <rect x="50" y="150" width="8" height="25" rx="1" fill="#8B7355"/>
        <path  d="M54 140 L45 155 L63 155 Z" fill="#6B9E78"/>
        <path d="M54 148 L46 160 L62 160 Z" fill="#5A8B68"/>
      </g>
      
      <g className="tree tree-far-2" opacity="0.7">
        <rect x="330" y="158" width="10" height="30" rx="1" fill="#8B7355"/>
        <path d="M335 135 L325 152 L345 152 Z" fill="#6B9E78"/>
        <path d="M335 145 L327 160 L343 160 Z" fill="#5A8B68"/>
      </g>
      
      {/* Road */}
      <path 
        d="M0 200 L0 300 L400 300 L400 200 Q350 210 300 205 Q250 200 200 205 Q150 210 100 205 Q50 200 0 200 Z" 
        fill="url(#roadGradient)"
      />
      
      {/* Road markings - dashed lines */}
      <g className="road-markings">
        <rect x="10" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-1"/>
        <rect x="60" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-2"/>
        <rect x="110" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-3"/>
        <rect x="160" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-4"/>
        <rect x="210" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-5"/>
        <rect x="260" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-6"/>
        <rect x="310" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-7"/>
        <rect x="360" y="230" width="30" height="4" rx="2" fill="#FCD34D" className="road-dash dash-8"/>
      </g>
      
      {/* Traffic signal */}
      <g className="traffic-signal">
        {/* Pole */}
        <rect x="187" y="125" width="6" height="80" rx="1" fill="#374151"/>
        <rect x="182" y="205" width="16" height="4" rx="1" fill="#374151"/>
        
        {/* Signal box */}
        <rect x="175" y="120" width="31" height="65" rx="4" fill="#1F2937"/>
        <rect x="177" y="122" width="27" height="61" rx="3" fill="#374151"/>
        
        {/* Lights */}
        <circle cx="190" cy="134" r="8" fill="#DC2626" className="traffic-light red-light"/>
        <circle cx="190" cy="134" r="10" fill="#DC2626" opacity="0.3" className="red-glow"/>
        <circle cx="190" cy="153" r="8" fill="#FCD34D" opacity="0.3" className="traffic-light yellow-light"/>
        <circle cx="190" cy="172" r="8" fill="#10B981" opacity="0.3" className="traffic-light green-light"/>
      </g>
      
      {/* Road sign - Speed Limit */}
      <g className="road-sign">
        <rect x="120" y="160" width="3" height="50" fill="#6B7280"/>
        <rect x="105" y="145" width="33" height="33" rx="2" fill="#FFFFFF" stroke="#DC2626" strokeWidth="3"/>
        <text x="121.5" y="167" fontSize="20" fontWeight="bold" fill="#1F2937" textAnchor="middle">40</text>
      </g>
      
      {/* Trees closer to road - right side */}
      <g className="tree tree-near-1">
        <rect x="370" y="165" width="12" height="35" rx="2" fill="#8B7355"/>
        <ellipse cx="376" cy="165" rx="20" ry="22" fill="#6B9E78"/>
        <ellipse cx="376" cy="170" rx="18" ry="20" fill="#5A8B68"/>
        <ellipse cx="376" cy="175" rx="15" ry="18" fill="#4A7A58"/>
      </g>
      
      <g className="tree tree-near-2">
        <rect x="15" y="170" width="10" height="30" rx="2" fill="#8B7355"/>
        <ellipse cx="20" cy="170" rx="18" ry="20" fill="#6B9E78"/>
        <ellipse cx="20" cy="175" rx="16" ry="18" fill="#5A8B68"/>
        <ellipse cx="20" cy="180" rx="13" ry="15" fill="#4A7A58"/>
      </g>
      
      {/* Small bushes */}
      <ellipse cx="250" cy="195" rx="25" ry="12" fill="#5A8B68" opacity="0.8"/>
      <ellipse cx="270" cy="195" rx="20" ry="10" fill="#4A7A58" opacity="0.8"/>
    </svg>
  );
};

export default DrivingEnvironment;
